import axios from 'axios'
import { Toast, Notify } from "vant";
import router from "../router";


const toLogin = () => {
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  })
}
let urlText 
if(localStorage.PlatformName){
  if(localStorage.PlatformName == 'YunJie'){
    // urlText = 'http://yjtp-fuel-service.youngbook.cn'
  urlText = process.env.VUE_APP_BASE_APITWO
  }else if (localStorage.PlatformName == 'KunMing') {
    urlText = process.env.VUE_APP_BASE_KUNMING
  }else if (localStorage.PlatformName == 'YuXi') {
    urlText = process.env.VUE_APP_BASE_YUXI
  }else if (localStorage.PlatformName == 'BanNa') {
    urlText = process.env.VUE_APP_BASE_BANNA
  }else{
    urlText = process.env.VUE_APP_BASE_APITWO
  }
}else{
  localStorage.PlatformName = 'YunJie'
  // urlText = 'http://yjtp-fuel-service.youngbook.cn'
  // urlText = 'http://yjtp-test-api.youngbook.cn'
  urlText = process.env.VUE_APP_BASE_APITWO
 
}
function isChange(name){
  if(name === 'YunJie'){
    return process.env.VUE_APP_BASE_APITWO
  }else if(name === 'KunMing'){
    return process.env.VUE_APP_BASE_KUNMING
  }else if(name === 'YuXi'){
    return process.env.VUE_APP_BASE_YUXI
  }else if(name === 'BanNa'){
    return process.env.VUE_APP_BASE_BANNA
  }
}

const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  baseURL: urlText,
  timeout: 150000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    //添加商城的Token
    config.headers['Ls-Mall-Token'] = localStorage.token

    if (config.params?.changeBaseUrl) {
        config.baseURL = isChange(config.params.changeBaseUrl);
        delete config.params.changeBaseUrl;
    }


    return config
  },
  error => {
    // Do something with request error
    console.log(error,'err') // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if(res.code == 403){
      Toast({
        message: "系统未登录，请重新登录",
        duration: 1500,
        forbidClick: true
      });
      toLogin()
      return Promise.reject('error')
    }
    if(res.code == 500){
      Toast({
        message: res.errmsg,
        duration: 1500,
        forbidClick: true
      });
      return Promise.reject('error')
    }
    // console.log(response,'response');
    return response
  }, error => {
    // console.log(error);
    return Promise.reject(error)
  })
export default service

